import { styled } from '@mui/material/styles';
import { Select, TextField } from '@mui/material';

export const SearchBarStyled = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    paddingTop: 1,
    paddingBottom: 1,
    '& fieldset': {
      borderColor: 'transparent',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
    },
  },
  // '& .MuiInputBase-input': {
  //   padding: '9.5px 12px',
  // },
}));

export const OrdersSelect = styled(Select<string>)(({ theme }) => ({
  minWidth: '150px',
  '& .MuiOutlinedInput-root': {
    border: 'none',
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '& .MuiSelect-select': {
    width: '160px',
    fontSize: '14px',
    borderRadius: '4px',
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    backgroundColor: theme.customColors.menuItem,
    '& .MuiInputBase-input': {
      paddingLeft: theme.spacing(1),
    },
  },
  '& .MuiInputBase-input:focus': {
    outline: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));
